import React from 'react';
import { useState } from 'react';
import SelectionButton from '../components/SelectionButton';
import './OrderListItem.css';

function OrderListItem(props) {

    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div className={`main-order-list-item-div main-order-list-item-div-${props.order.status}`} onClick={() => setIsExpanded(!isExpanded)}>
            <div className='unexpanded-div'>
                <h3 className='order-list-item'>#{props.order.orderId}: {props.order.name} - {props.order.displayStatus}</h3>
                {
                    isExpanded ? <h3 className='arrow-up'>&#9650;</h3> : <h3 className='arrow-down'>&#9660;</h3>
                }
            </div>          
            {
                isExpanded ? <div className={`expanded-div expanded-div-${props.order.status}`}>
                    {
                        props.order.orderItems.map((item, idx) => typeof item === 'string' || item instanceof String ?
                        <div className='alacarte-item list-order-item' key={idx}>
                            <p>{item}</p>
                        </div> :
                        <div className='meal-list-order-item list-order-item' key={idx}>
                            <h5 className='order-list-meal-heading'>Meal</h5>
                            {
                                item.entrees.map((entree, i) => 
                                    <p key={i} style={{textIndent: "2em"}}>{entree}</p>)
                            }
                            {
                                item.sides.map((side, i) => 
                                    <p key={i} style={{textIndent: "2em"}}>{side}</p>)
                            }
                            {
                                item.extras ? item.extras.map((extra, i) =>
                                    <p key={i} style={{textIndent: "2em"}}>{extra}</p>) : null
                            }
                        </div>
                        )
                    }
                    {
                        props.order.status === 'todo' ? 
                            <SelectionButton buttonText='In Progress' onClickFunction={() => props.changeOrderStatus(props.order.orderId, 'inProgress', 'In Progress')} /> : null
                    }
                    {
                        props.order.status === 'inProgress' ?
                            <SelectionButton buttonText='Finish' onClickFunction={() => props.changeOrderStatus(props.order.orderId, 'finished', 'Finished')} /> : null
                    }
                </div> : null
            }
        </div>
    );
}

export default OrderListItem;